import { useState } from "react";
import PropTypes from "prop-types";
import { Avatar } from "@mui/material";

const DEFAULT_PLACEHOLDER_KEY = "default-profile";

const AvatarWithInitials = ({ name, src, sx, alt, ...props }) => {
  const [failed, setFailed] = useState(false);

  const isPlaceholder = typeof src === "string" && src.toLowerCase().includes(DEFAULT_PLACEHOLDER_KEY);
  const showInitials = failed || !src || isPlaceholder;

  const initials = name
    ? name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .slice(0, 2)
        .toUpperCase()
    : "";

  return (
    <Avatar {...props} alt={alt || name} src={showInitials ? undefined : src} sx={sx} onError={() => setFailed(true)}>
      {showInitials ? initials : null}
    </Avatar>
  );
};

AvatarWithInitials.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  sx: PropTypes.object,
  alt: PropTypes.string,
};

export default AvatarWithInitials;
